
















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<BaseFormMessage>({})
export default class BaseFormMessage extends Vue {
    @Prop(Boolean) public readonly error?: boolean
    @Prop(String) public readonly title?: string
}
